module.exports = __webpack_public_path__ + "static/media/slideMobile03.6be646c8.jpg";